<div class="p-support-info">
  <div class="p-support-info__head">
    <h2 class="p-support-info__head-title" [innerHTML]="'label.foldingWheelchair' | staticMsg"></h2>
  </div>
  <div class="p-support-info__body">
    <!-- [14.13] 折りたたみ可否 -->
    <div class="p-support-info__item">
      <div class="p-support-info__row">
        <fieldset class="p-support-info__radio" role="radiogroup" aria-invalid="false">
          <legend class="p-support-info__radio-legend" [innerHTML]="'label.foldingWheelchair' | staticMsg"></legend>
          <div class="p-support-info__radio-list">
            <div class="p-support-info__radio-item">
              <input
                type="radio"
                name="radio1"
                id="radio1_1"
                class="p-support-info__radio-item-input"
                (change)="onChangeFoldable(true)"
                [checked]="isFoldable === true"
              />
              <label for="radio1_1" class="p-support-info__radio-item-label">
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text" [innerHTML]="'label.foldable' | staticMsg"></span>
                </span>
              </label>
            </div>
            <div class="p-support-info__radio-item">
              <input
                type="radio"
                name="radio1"
                id="radio1_2"
                class="p-support-info__radio-item-input"
                (change)="onChangeFoldable()"
                [checked]="isFoldable === false"
              />
              <label for="radio1_2" class="p-support-info__radio-item-label">
                <span class="p-support-info__radio-item-check"></span>
                <span class="p-support-info__radio-item-text-wrap">
                  <span class="p-support-info__radio-item-text" [innerHTML]="'label.notFoldable' | staticMsg"></span>
                </span>
              </label>
            </div>
          </div>
        </fieldset>
        <asw-validation-error
          *ngIf="selectError"
          id="{{ id }}_foldable-error"
          [errorMessage]="selectError"
        ></asw-validation-error>
      </div>
    </div>
    <!-- [14.14] サイズ情報 -->
    <ng-container [formGroup]="formGroup" *ngIf="!isFoldable">
      <div class="p-support-info__item">
        <div class="p-support-info__item-title">
          {{ 'label.size' | staticMsg }}
          <!-- [14.5] サポート情報追加 -->
          <asw-tooltip
            iconImage="<img src=&quot;assets/images/icon_help_primary_20.svg&quot; alt={{
              'm_static_message-alt.helpIcon2' | staticMsg
            }} width=&quot;20&quot; height=&quot;20&quot;>"
            [tooltipContent]="'tooltip.size' | staticMsg"
            [displayAreaClass]="'p-support-info'"
          ></asw-tooltip>
        </div>
        <div class="p-support-info__row">
          <div class="p-support-info__item-column p-support-info__item-column--3">
            <div class="p-support-info__item-column-box">
              <div
                class="c-form-element-input"
                [ngClass]="{
                  'is-error': getError(formGroup.controls['depth']),
                  'is-disabled': isFoldable !== false
                }"
              >
                <div class="c-form-element-input__box">
                  <label class="c-form-element-input__wrap">
                    <span class="c-form-element-input__label">
                      <span class="c-form-element-input__label-text" [innerHTML]="'label.depth' | staticMsg"></span>
                    </span>
                    <span class="c-form-element-input__input l-mybooking__title-status">
                      <!-- [14.15] 奥行 -->
                      <input
                        #depthInputElement
                        maxlength="3"
                        type="text"
                        class="c-form-element-input__input-item"
                        formControlName="depth"
                        [alt]="'reader.depth' | staticMsg"
                        (input)="onChangeDepth(depthInput)"
                      />
                      <span class="c-text-m c-text-m--bold" [innerHTML]="'label.centimetre' | staticMsg"></span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="p-support-info__item-column-box">
              <div
                class="c-form-element-input"
                [ngClass]="{
                  'is-error': getError(formGroup.controls['width']),
                  'is-disabled': isFoldable !== false
                }"
              >
                <div class="c-form-element-input__box">
                  <label class="c-form-element-input__wrap">
                    <span class="c-form-element-input__label">
                      <span class="c-form-element-input__label-text" [innerHTML]="'label.width' | staticMsg"></span>
                    </span>
                    <span class="c-form-element-input__input l-mybooking__title-status">
                      <!-- [14.16] 横幅 -->
                      <input
                        #widthInputElement
                        maxlength="3"
                        type="text"
                        class="c-form-element-input__input-item"
                        formControlName="width"
                        [alt]="'reader.width' | staticMsg"
                        (input)="onChangeWidth(widthInput)"
                      />
                      <span class="c-text-m c-text-m--bold" [innerHTML]="'label.centimetre' | staticMsg"></span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
            <div class="p-support-info__item-column-box">
              <div
                class="c-form-element-input"
                [ngClass]="{
                  'is-error': getError(formGroup.controls['height']),
                  'is-disabled': isFoldable !== false
                }"
              >
                <div class="c-form-element-input__box">
                  <label class="c-form-element-input__wrap">
                    <span class="c-form-element-input__label">
                      <span class="c-form-element-input__label-text" [innerHTML]="'label.height' | staticMsg"></span>
                    </span>
                    <span class="c-form-element-input__input l-mybooking__title-status">
                      <!-- [14.17] 高さ -->
                      <input
                        #heightInputElement
                        maxlength="3"
                        type="text"
                        class="c-form-element-input__input-item"
                        formControlName="height"
                        [alt]="'reader.height' | staticMsg"
                        (input)="onChangeHeight(heightInput)"
                      />
                      <span class="c-text-m c-text-m--bold" [innerHTML]="'label.centimetre' | staticMsg"></span>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div
            class="p-support-info__item-column p-support-info__item-column--3"
            style="margin-top: 15px"
            *ngIf="
              getError(formGroup.controls['depth']) ||
              getError(formGroup.controls['width']) ||
              getError(formGroup.controls['height'])
            "
          >
            <div class="p-support-info__item-column-box">
              <asw-validation-error
                *ngIf="formGroup.controls['depth'].errors"
                id="{{ id }}_weelchair-depth-error"
                [errorMessage]="getError(formGroup.controls['depth'])"
              ></asw-validation-error>
            </div>
            <div class="p-support-info__item-column-box">
              <asw-validation-error
                *ngIf="formGroup.controls['width'].errors"
                id="{{ id }}_weelchair-width-error"
                [errorMessage]="getError(formGroup.controls['width'])"
              ></asw-validation-error>
            </div>
            <div class="p-support-info__item-column-box">
              <asw-validation-error
                *ngIf="formGroup.controls['height'].errors"
                id="{{ id }}_weelchair-height-error"
                [errorMessage]="getError(formGroup.controls['height'])"
              ></asw-validation-error>
            </div>
          </div>
        </div>
      </div>
      <div class="p-support-info__item">
        <div class="p-support-info__row">
          <div
            class="c-form-element-input"
            [ngClass]="{
              'is-error': getError(formGroup.controls['weight']),
              'is-disabled': isFoldable !== false
            }"
          >
            <div class="c-form-element-input__box">
              <label class="c-form-element-input__wrap">
                <span class="c-form-element-input__label">
                  <span class="c-form-element-input__label-text" [innerHTML]="'label.weight' | staticMsg"></span>
                </span>
                <span class="c-form-element-input__input l-mybooking__title-status">
                  <!-- [14.18] 重さ -->
                  <input
                    #weightInputElement
                    maxlength="3"
                    type="text"
                    class="c-form-element-input__input-item"
                    formControlName="weight"
                    [alt]="'reader.weight' | staticMsg"
                    (input)="onChangeWeight(weightInput)"
                  />
                  <span class="c-text-m c-text-m--bold" [innerHTML]="'label.kilogram' | staticMsg"></span>
                </span>
              </label>
            </div>
          </div>
          <asw-validation-error
            *ngIf="formGroup.controls['weight'].errors"
            id="{{ id }}_wheelchair-weight-error"
            [errorMessage]="getError(formGroup.controls['weight'])"
          ></asw-validation-error>
        </div>
      </div>
    </ng-container>
  </div>
</div>
